import React, { useState, useEffect } from 'react';
import { toast } from 'sonner';
import { Plus, Edit, Trash2, Eye, EyeOff } from 'lucide-react';

import { authHeaders } from '../lib/authToken';
const BACKEND = process.env.REACT_APP_BACKEND_URL;

export default function AdminBlog() {
  const [articles, setArticles] = useState([]);
  const [loading, setLoading] = useState(true);
  const [form, setForm] = useState({ titre: '', slug: '', contenu: '', extrait: '', image: '', tags: '', publie: false, localite: '', seo_title: '', seo_description: '' });
  const [showForm, setShowForm] = useState(false);
  const [editId, setEditId] = useState(null);

  useEffect(() => { fetchArticles(); }, []);

  async function fetchArticles() {
    fetch(`${BACKEND}/api/blog`).then(r => r.json()).then(d => setArticles(d.articles || [])).catch((err) => { /* eslint-disable-line no-empty */ }).finally(() => setLoading(false));
  }

  async function saveArticle() {
    const payload = { ...form, tags: form.tags ? form.tags.split(',').map(t => t.trim()) : [] };
    const url = editId ? `${BACKEND}/api/blog/${editId}` : `${BACKEND}/api/blog`;
    const method = editId ? 'PUT' : 'POST';
    const res = await fetch(url, { method, headers: authHeaders({ 'Content-Type': 'application/json' }), body: JSON.stringify(payload) });
    if (res.ok) { toast.success(editId ? 'Article mis à jour' : 'Article créé'); setShowForm(false); fetchArticles(); }
  }

  async function togglePublish(a) {
    const url = a.publie ? `${BACKEND}/api/blog/${a.id}` : `${BACKEND}/api/blog/${a.id}/publier`;
    const method = a.publie ? 'PUT' : 'PUT';
    await fetch(url, { method, headers: authHeaders({ 'Content-Type': 'application/json' }), body: JSON.stringify({ publie: !a.publie }) });
    fetchArticles();
  }

  async function deleteArticle(id) {
    if (!window.confirm('Supprimer ?')) return;
    await fetch(`${BACKEND}/api/blog/${id}`, { method: 'DELETE', headers: authHeaders() });
    fetchArticles();
  }

  return (
    <div>
      <div style={{ marginBottom: 20 }}>
        <p className="adm-eyebrow">Parametres</p>
        <h2 style={{ fontFamily: 'var(--admin-font-display)', fontSize: 26, fontWeight: 700,
          letterSpacing: '-.6px', color: 'var(--admin-text)', marginTop: 4 }}>Blog & Contenu SEO</h2>
        <p style={{ color: 'var(--admin-muted)', fontSize: 13.5, marginTop: 3 }}>Articles, SEO et contenu</p>
      </div>

      <div className="flex items-center justify-between mb-6">
        <h2 className="font-display text-xl font-bold" style={{ color: 'var(--admin-text)' }}>Blog SEO</h2>
        <button onClick={() => { setShowForm(true); setEditId(null); setForm({ titre: '', slug: '', contenu: '', extrait: '', image: '', tags: '', publie: false, localite: '', seo_title: '', seo_description: '' }); }}
          className="btn-gold px-4 py-2 rounded-xl text-sm font-semibold flex items-center gap-2">
          <Plus size={16} /> Nouvel article
        </button>
      </div>

      {showForm && (
        <div className="mb-6 p-5 rounded-xl" style={{ background: 'var(--admin-surface)', border: '1px solid rgba(212,175,55,0.2)' }}>
          <div className="grid sm:grid-cols-2 gap-4">
            <div><label className="block text-xs mb-1" style={{ color: 'var(--admin-muted)' }}>Titre *</label>
              <input type="text" value={form.titre} onChange={e => setForm(p => ({ ...p, titre: e.target.value, slug: e.target.value.toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, '') }))}
                className="w-full px-3 py-2.5 rounded-xl text-sm" style={{ background: '#1C1C1C', border: '1px solid #2A2A2A', color: 'var(--admin-text)' }} /></div>
            <div><label className="block text-xs mb-1" style={{ color: 'var(--admin-muted)' }}>Slug</label>
              <input type="text" value={form.slug} onChange={e => setForm(p => ({ ...p, slug: e.target.value }))}
                className="w-full px-3 py-2.5 rounded-xl text-sm" style={{ background: '#1C1C1C', border: '1px solid #2A2A2A', color: 'var(--admin-text)' }} /></div>
            <div className="sm:col-span-2"><label className="block text-xs mb-1" style={{ color: 'var(--admin-muted)' }}>Contenu</label>
              <textarea rows={6} value={form.contenu} onChange={e => setForm(p => ({ ...p, contenu: e.target.value }))}
                className="w-full px-3 py-2.5 rounded-xl text-sm resize-y" style={{ background: '#1C1C1C', border: '1px solid #2A2A2A', color: 'var(--admin-text)' }} /></div>
            <div><label className="block text-xs mb-1" style={{ color: 'var(--admin-muted)' }}>Tags (virgules)</label>
              <input type="text" value={form.tags} onChange={e => setForm(p => ({ ...p, tags: e.target.value }))}
                className="w-full px-3 py-2.5 rounded-xl text-sm" style={{ background: '#1C1C1C', border: '1px solid #2A2A2A', color: 'var(--admin-text)' }} /></div>
            <div><label className="block text-xs mb-1" style={{ color: 'var(--admin-muted)' }}>Localité</label>
              <input type="text" value={form.localite} onChange={e => setForm(p => ({ ...p, localite: e.target.value }))}
                className="w-full px-3 py-2.5 rounded-xl text-sm" style={{ background: '#1C1C1C', border: '1px solid #2A2A2A', color: 'var(--admin-text)' }} /></div>
          </div>
          <div className="flex gap-3 mt-4">
            <button onClick={() => setShowForm(false)} className="px-4 py-2 rounded-xl text-sm" style={{ background: '#2A2A2A', color: 'rgba(255,255,255,0.6)' }}>Annuler</button>
            <button onClick={saveArticle} className="flex-1 btn-gold py-2 rounded-xl text-sm font-semibold">Enregistrer</button>
          </div>
        </div>
      )}

      <div className="rounded-xl overflow-hidden" style={{ border: '1px solid #2A2A2A' }}>
        {articles.map((a, i) => (
          <div key={a.id} className="flex items-center gap-3 px-4 py-3" style={{ background: i % 2 === 0 ? '#161616' : '#121212', borderBottom: '1px solid rgba(42,42,42,0.5)' }}>
            <div className="flex-1">
              <p className="text-sm font-semibold" style={{ color: 'var(--admin-text)' }}>{a.titre}</p>
              <p className="text-xs" style={{ color: 'var(--admin-muted)' }}>/blog/{a.slug}</p>
            </div>
            <div className="flex items-center gap-2">
              <span className={`text-xs px-2 py-0.5 rounded-full`} style={{ background: a.publie ? 'rgba(61,220,151,0.12)' : 'rgba(207,207,207,0.1)', color: a.publie ? '#3DDC97' : '#CFCFCF' }}>
                {a.publie ? 'Publié' : 'Brouillon'}
              </span>
              <button onClick={() => togglePublish(a)} className="p-1.5 rounded-lg" style={{ background: 'var(--admin-gold-dim)', color: 'var(--admin-gold)' }}>{a.publie ? <EyeOff size={14} /> : <Eye size={14} />}</button>
              <button onClick={() => deleteArticle(a.id)} className="p-1.5 rounded-lg" style={{ background: 'rgba(255,92,108,0.1)', color: '#FF5C6C' }}><Trash2 size={14} /></button>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
